import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CountdownCard from './components/CountdownCard';
import CTABanner from './components/CTABanner';
import WhoCanParticipate from './components/WhoCanParticipate';
import WhyParticipate from './components/WhyParticipate';
import EventInfo from './components/EventInfo';
import AboutFourModels from './components/AboutFourModels';
import SuccessStories from './components/SuccessStories';
import SpecialGuest from './components/SpecialGuest';
import RegistrationForm from './components/RegistrationForm';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CountdownCard />
        <CTABanner />
        <WhoCanParticipate />
        <WhyParticipate />
        <EventInfo />
        <AboutFourModels />
        <SuccessStories />
        <SpecialGuest />
        <RegistrationForm />
      </main>
      <Footer />
    </div>
  );
}